// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2fgl6","box":"WorkspacesBox_box__69gB4","node":"WorkspacesBox_node__DTFhe"};